import { useState, useEffect } from "react";
import estilos from "./Cabecalho.module.css";

const linksNavegacao = [
  { nome: "Sobre", href: "#sobre" },
  { nome: "Stack", href: "#stack" },
  { nome: "Projetos", href: "#projetos" },
  { nome: "Experiência", href: "#experiencia" },
  { nome: "Contato", href: "#contato" },
];

const Cabecalho = () => {
  const [comFundo, setComFundo] = useState(false);
  const [menuAberto, setMenuAberto] = useState(false);

  useEffect(() => {
    const aoRolar = () => setComFundo(window.scrollY > 50);
    window.addEventListener("scroll", aoRolar);
    return () => window.removeEventListener("scroll", aoRolar);
  }, []);

  return (
    <header
      className={`${estilos.cabecalho} ${comFundo ? estilos.cabecalhoComFundo : ""}`}
    >
      <div className={estilos.container}>
        <a href="#" className={estilos.logo}>
          W<span className={estilos.logoPonto}>.</span>F
        </a>

        <nav className={estilos.navegacao}>
          {linksNavegacao.map((link) => (
            <a key={link.href} href={link.href} className={estilos.link}>
              {link.nome}
            </a>
          ))}
        </nav>

        <button
          className={estilos.menuMobile}
          onClick={() => setMenuAberto(!menuAberto)}
          aria-label="Menu"
        >
          <svg className={estilos.menuMobileIcone} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {menuAberto ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      <nav
        className={`${estilos.navegacaoMobile} ${menuAberto ? estilos.navegacaoMobileAberta : ""}`}
      >
        {linksNavegacao.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className={estilos.link}
            onClick={() => setMenuAberto(false)}
          >
            {link.nome}
          </a>
        ))}
      </nav>
    </header>
  );
};

export default Cabecalho;
